export default "__VITE_ASSET__Buw7b_CL__"